$(document).ready(function () {
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  var filtervar = getUrlParameter("filters");
  var sortvar = getUrlParameter("sort_by");

  if (typeof filtervar !== "undefined") {
    var array = filtervar.split(",");
    $.each(array, function (i) {
      $(".filter-type.filter").each(function () {
        if ($(this).data("value") == array[i]) {
          $(this).addClass("medium");
        }
      });
    });
  } else {
    $(".filter-type.filter.all-prods").addClass("medium");
  }

  if (typeof sortvar !== "undefined") {
    $(".filter-type.sort").removeClass("medium");
    var array = sortvar.split(",");
    $.each(array, function (i) {
      $(".filter-type.sort").each(function () {
        if ($(this).data("value") == array[i]) {
          $(this).addClass("medium");
        }
      });
    });
  }
  var collex = window.location.href.split("/").pop().split("?")[0];
  $(".filter-type.collection").each(function () {
    console.log($(this).data("value"));
    console.log(collex);
    if ($(this).data("value") == collex) {
      $(this).addClass("medium");
    }
  });

  function runFilter() {
    var classString = "";
    var i;
    $(".product-card").addClass("no-disp");

    $(".product-card").addClass("fop");
    var label_text = $(".products-grid-title").data("title");
    if ($(".filter-type.filter.medium").length > 0) {
      var arrClass = [];
      var arrLabel = [];
      $(".product-card").data("iteration", 0);
      $(".filter-type.filter.medium").each(function () {
        arrClass.push($(this).data("value"));
        arrLabel.push($(this).data("label"));
      });

      label_text = arrLabel[0];
      $.each(arrClass, function (index, val) {
        $(".product-card").each(function (i, v) {
          if ($(this).hasClass("tag-" + val)) {
            $(this).data(
              "iteration",
              (parseInt($(this).data("iteration")) || 0) + 1
            );
          }
        });
        $(".product-card").each(function (i, v) {
          if (
            $(this).data("iteration") ==
              $(".filter-type.filter.medium").length &&
            $(this).hasClass("fop")
          ) {
            $(this).removeClass("no-disp");
          }
        });
      });
    } else {
      $(".product-card").removeClass("no-disp");
    }
    if ($(".filter-type.filter.medium.all-prods").length > 0){
      $(".product-card").removeClass("no-disp");
    }
    $(".products-grid-title").html(label_text);
    $(".fop").removeClass("fop");
    $(".no-of-prods").text($(".product-card:not(.no-disp)").length);
  }
  runFilter();

  $(".filter-type.sort").click(function () {
    var sortx = "";
    if ($(this).hasClass("medium")) {
      $(".filter-type.sort").removeClass("medium");
      sortx = "?";
    } else {
      $(".filter-type.sort").removeClass("medium");
      $(this).addClass("medium");
      sortx = "?sort_by=" + $(this).data("value");
    }
    var filtersx = "";
    if ($(".filter-type.filter.medium").length > 0) {
      if ($(".filter-type.sort.medium").length > 0) {
        filtersx = "&filters=";
      } else {
        filtersx = "filters=";
      }
      $(".filter-type.filter.medium").each(function (index) {
        if (index > 0) {
          filtersx += "," + $(this).data("value");
        } else {
          filtersx += $(this).data("value");
        }
      });
    }
    var url =
      "https://" +
      window.location.hostname +
      "/collections/" +
      window.location.href.split("/").pop().split("?")[0] +
      sortx +
      filtersx;
    window.history.pushState({}, null, url);
    localStorage.setItem("PrevLocation", url);
    $.ajax({
      url: url,
      method: "GET",
    })
      .done(function (data) {
        var placeholder = document.createElement("div");
        placeholder.innerHTML = data;
        var divx = $(placeholder).find(".prod-coll-page");
        $(".prod-coll-page")
          .first()
          .replaceWith(placeholder.querySelector(".prod-coll-page"));
        runFilter();
      })
      .fail(function (error) {
        console.log(error);
      });
  });

  $(".filter-type.filter").click(function () {
    if ($(this).hasClass("colors-filter")) {
      if ($(this).hasClass("medium")) {
        $(this).removeClass("medium");
      } else {
        $(this)
          .parent()
          .find(".filter-type.colors-filter")
          .removeClass("medium");
        $(this).addClass("medium");
      }
    } else {
      $(this).toggleClass("medium");
    }

    var filtersx = "";
    if ($(".filter-type.filter.medium").length > 0) {
      if ($(".filter-type.sort.medium").length > 0) {
        filtersx = "&filters=";
      } else {
        filtersx = "filters=";
      }
      if($('.filter-type.filter.medium').hasClass('all-prods')){
        filtersx = '';
      }
      $(".filter-type.filter.medium").each(function (index) {
        if (index > 0) {
          filtersx += "," + $(this).data("value");
        } else {
          filtersx += $(this).data("value");
        }
      });
    }
    var sortx = "?";
    if ($(".filter-type.sort.medium").length > 0) {
      sortx = "?sort_by=" + $(".filter-type.sort.medium").data("value");
    }
    if($('.filter-type.filter.medium').hasClass('all-prods')){
        sortx = '';
      }
    var url =
      "https://" +
      window.location.hostname +
      "/collections/" +
      window.location.href.split("/").pop().split("?")[0] +
      sortx +
      filtersx;
    window.history.pushState({}, null, url);
    localStorage.setItem("PrevLocation", url);
    runFilter();
  });

  $(".filter-type.collection").click(function () {
    var collx;
    if ($(this).hasClass("medium")) {
      $(".filter-type.collection").removeClass("medium");
      collx = "all";
    } else {
      $(".filter-type.collection").removeClass("medium");
      $(this).addClass("medium");
      collx = $(this).data("value");
    }
    var filtersx = "";
    if ($(".filter-type.filter.medium").length > 0) {
      if ($(".filter-type.sort.medium").length > 0) {
        filtersx = "&filters=";
      } else {
        filtersx = "filters=";
      }
      $(".filter-type.filter.medium").each(function (index) {
        if (index > 0) {
          filtersx += "," + $(this).data("value");
        } else {
          filtersx += $(this).data("value");
        }
      });
    }
    var sortx = "?";
    if ($(".filter-type.sort.medium").length > 0) {
      sortx = "?sort_by=" + $(".filter-type.sort").data("value");
    }
    var url =
      "https://" +
      window.location.hostname +
      "/collections/" +
      collx +
      sortx +
      filtersx;
    window.history.pushState({}, null, url);
    localStorage.setItem("PrevLocation", url);
    $.ajax({
      url: url,
      method: "GET",
    })
      .done(function (data) {
        var placeholder = document.createElement("div");
        placeholder.innerHTML = data;
        var divx = $(placeholder).find(".prod-coll-page");
        console.log($(placeholder));
        $(".prod-coll-page")
          .first()
          .replaceWith(placeholder.querySelector(".prod-coll-page"));
        runFilter();
      })
      .fail(function (error) {
        console.log(error);
      });
  });
}); 
